// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "console-app." + "85c5930723ca8eb00f2e" + ".js";
};